/**
 * Focus trap — traps keyboard focus inside a container element (WCAG 2.4.3).
 */

const FOCUSABLE_SELECTOR =
  'button:not([disabled]):not([hidden]), ' +
  'input:not([disabled]):not([hidden]), ' +
  '[tabindex]:not([tabindex="-1"]):not([disabled])';

export function trapFocus(container: HTMLElement, e: KeyboardEvent): void {
  const focusable = container.querySelectorAll<HTMLElement>(FOCUSABLE_SELECTOR);
  if (focusable.length === 0) return;

  const first = focusable[0];
  const last = focusable[focusable.length - 1];

  if (e.shiftKey && document.activeElement === first) {
    e.preventDefault();
    last.focus();
  } else if (!e.shiftKey && document.activeElement === last) {
    e.preventDefault();
    first.focus();
  }
}

export function announceToSR(message: string): void {
  const el = document.createElement('div');
  el.setAttribute('role', 'status');
  el.setAttribute('aria-live', 'polite');
  el.className = 'flt-tm-sr-only';
  el.textContent = message;
  document.body.appendChild(el);
  setTimeout(() => el.remove(), 3000);
}
